module.exports = __webpack_public_path__ + "static/img/restoration.25584fec.png";